import { getRoute } from 'layout_congress/js/urls.mts'
import { RouteRecordRaw } from "vue-router"

import adminRoutes from './admin/routes.mjs'
import userRoutes from './user/routes.mjs'
import welcomePageRoutes from './welcome/routes.mjs'

import { $pgettext } from 'gettext-congress'

const getRootRoute: typeof getRoute = (...args) => '/' + getRoute(...args)

export const routes: RouteRecordRaw[] = [
    {
        path: '/',
        redirect: '/proposals',
    },
    {
        path: getRootRoute('proposal_collection:WelcomeView'),
        children: welcomePageRoutes,
    },
    {
        path: "/:lang/proposals/",
        children: [
            {
                path: "u/:collection_uid/",
                meta: {
                    "entrypoint": true,
                    "aside": false,
                    "menu": 'user',
                    breadcrumbs: [
                        [$pgettext("Home link text", "Home"), '/?ignore-magnet-redirect'],
                    ],
                },
                children: userRoutes,
            },
            {
                path: "a/:collection_uid/",
                meta: {
                    "entrypoint": true,
                    "aside": true,
                    "menu": 'admin',
                },
                children: adminRoutes,
            }
        ],
    },
]

function * get_paths(parent: string, records: RouteRecordRaw[]) {
    for (const routeRecord of records) {
        const { path, name = 'unnamed', children } = routeRecord
        const pathWithPrefix = path.startsWith('/') ? path: `${parent}${path}`
        yield `${pathWithPrefix}: ${String(name)}`
        yield * get_paths(pathWithPrefix, children ?? [])
    }
}

console.debug("proposal_collection paths", [...get_paths('', routes)])

console.debug("proposal_collection routes", routes)
export default routes
